import React from 'react';
import { IMAGE_SECTION_ITEMS } from '../constants/images';
import './ImageSection.css';

const ImageSection = () => (
  <section className="image-section" id="gallery">
    <div className="container">
      <div className="image-section-header">
        <div className="section-badge">REAL INVENTORY</div>
        <h2 className="section-title">Quality Used OEM Parts<br />Ready to Ship</h2>
        <p className="section-desc">
          Every part is photographed, graded, and tested before it reaches our shelves.
          Browse a glimpse of the used auto parts our customers trust every day.
        </p>
      </div>

      <div className="image-section-grid">
        {IMAGE_SECTION_ITEMS.map(({ src, alt, caption }) => (
          <figure className="image-section-card" key={src}>
            <div className="image-section-img-wrap">
              <img src={src} alt={alt} loading="lazy" />
            </div>
            <figcaption className="image-section-caption">{caption}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default ImageSection;
